import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 -80px',
    padding: '12px 80px',
    borderBottom: `1px solid ${colors.ghostBorder}`,
    background: colors.primaryBackground,
  },
  containerPreviewTemplate: {
    position: 'sticky',
    marginTop: 'auto',
    transform: 'translateY(40px)',
    order: 1,
    bottom: 0,
    zIndex: 10,
  },
  logo: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
  },
});
